import { useEffect } from "react";
import { useDebounce } from "@react-hook/debounce";
import { useSelector } from "react-redux";

/**
 * Debounces values selected from the Redux store.
 *
 * @param selector Redux selector (RootState) => TSelected
 * @param wait debounce duration (ms)
 * @param leading whether to emit the leading value immediately
 * @returns debounced selector value
 */
export const useDebounceSelector = <TSelected>(
  selector: (state: RootState) => TSelected,
  wait = 250,
  leading = false,
): TSelected => {
  const selectorData = useSelector<RootState, TSelected>(selector);

  const [data, setData] = useDebounce<TSelected>(selectorData, wait, leading);

  useEffect(() => {
    setData(selectorData);
  }, [selectorData, setData]);

  return data;
};
